import * as React from "react";
import { HBox, VBox } from "framework/structural_components/hbox_vbox";
import { Filter } from "./filter/view";
import { List } from "./list/view";
import { cls_colorCyan70 } from "style/index.css";
import { cls_box_caption } from "./view.css";
import { Route, Switch } from "wouter";
import { detailPageFromString } from "./store";
import { UrlPathOfPublicSection } from "common/paths";
var Content = function (props) {
    return React.createElement(VBox, null,
        React.createElement(HBox, { className: cls_box_caption },
            React.createElement("h3", { className: cls_colorCyan70 }, 'Kalendář akcí')),
        React.createElement(Filter, null),
        React.createElement(List, { eventId: props.eventId, eventCompetitionId: props.eventCompetitionId, tabId: props.tabId }));
};
var View = function () {
    return React.createElement(Switch, null,
        React.createElement(Route, { path: "".concat(UrlPathOfPublicSection, "/kalendar_akci/event/:eventId/competition/:eventCompetitionId/:tabId") }, function (params) { return params ? React.createElement(Content, { eventId: parseInt(params.eventId), eventCompetitionId: parseInt(params.eventCompetitionId), tabId: detailPageFromString(params.tabId) }) : null; }),
        React.createElement(Route, null, React.createElement(Content, null)));
};
export { View as EventCalendar, };
